<script lang="js" setup>
</script>

<template>
  <n-select
    size="large" class="tt-select" placeholder=""
    v-bind="$attrs"
  >
    <template #arrow>
      <SvgoCommonSelectArrow class="!w-2 !h-[6px] text-textPrimary mx-auto mt-1" />
    </template>
    <template #empty>
      <common-noData class="pt-0" />
    </template>
    <template v-for="name in Object.keys($slots)" :key="name" #[name]>
      <slot :name="name" />
    </template>
  </n-select>
</template>

<style lang="scss" scoped>
.tt-select{
  :deep(.n-base-selection){
    input {
      box-shadow: none !important;
    }
  }
}
</style>
